import React, { createContext, useContext, useState } from 'react';

const NodeJSContext = createContext(null);

export const NodeJSProvider = ({ children, executeNotebookCell }) => {

  const [isLoading] = useState(false);
  const [error]     = useState(null);

  const runCode = async (code, cellId) => {
    try {
      const response = await executeNotebookCell(cellId, code);

      if (response?.success) {
        return {
          stdout: response.stdout || '',
          stderr: response.stderr || '',
          plot:   response.plot   || null,
          error:  response.error  || null,
        };
      } else {
        return {
          stdout: '',
          stderr: '',
          plot:   null,
          error:  response?.error || 'Execution failed',
        };
      }
    } catch (err) {
      return {
        stdout: '',
        stderr: '',
        plot:   null,
        error:  err.message || 'Network error',
      };
    }
  };

  return (
    <NodeJSContext.Provider value={{ pyodide: null, isLoading, error, runCode }}>
      {children}
    </NodeJSContext.Provider>
  );
};

export const useNodeJS = () => {
  return useContext(NodeJSContext);
};